// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCheck_root__zSrpI"};